import { Container, Button, Jumbotron, ListGroup, Row, Col, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";
import brand from "../../assets/img/logo-vertical-colored.svg";
import Brand from "../../assets/img/imageIcon.png";
import products from "./img/Products-bro.svg";
import baker from "./img/Baker-bro.svg";
import credit from "./img/Credit-bro.svg";
import barcode from "./img/Barcode-bro.svg";
import marketing from "./img/Marketing-bro.svg";
import paid from "./img/Paid-bro.svg";
import analysis from "./img/Analysis-bro.svg";
import people from "./img/People-bro.svg";
import fruitshop from "./img/FruitShop-bro.svg";
import { MdEdit, MdWhatsapp, MdCheck } from "react-icons/md";
import { FaTelegramPlane, FaBolt, FaCut, FaLock, FaHandshake, FaQuestionCircle, FaHistory, FaShoppingBag } from 'react-icons/fa';
import "./styles.scss";
import { Helmet } from "react-helmet";
import qr from "../../assets/img/QR Code - Grupos de Ofertas.png"
export default function Home() {
  const baseURL =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_MERCADIM_BASE_URL_PRO
      : process.env.REACT_APP_MERCADIM_BASE_URL_DEV;
  return (
    <>
      <Helmet title="Caçadores de Ofertas: Home" />
      <div className="banner-cacadores">
        <Container>
          <Row className="align-items-center">
            <Col lg={4} className="text-right">
              <img src={Brand} alt="Caçadores de ofertas" className="brand-logo" />
            </Col>
            <Col lg={5}>
              <h1>Participe dos grupos de oferta no WhatsApp e Telegram</h1>
              <p>Criamos grupos no WhatsApp e no Telegram 100% gratuitos, onde divulgamos todos os dias as melhores promoções das principais lojas do Brasil para você economizar! Não perca tempo, entre e compartilhe com seus amigos.</p>
              <div className="banner-buttons">
                <a href="https://t.me/s/cacadoresofertas" rel="noopener noreferrer" className="promo-button-link">
                  <Button variant="outline-light" className="btn-block btn-telegram">
                    <FaTelegramPlane /> GRUPO NO TELEGRAM
                  </Button>
                </a>
                <br />
                <a href={`${baseURL}entrar?tipo=ofertas`} rel="noopener noreferrer" className="promo-button-link">
                  <Button variant="success" className=" btn-whatsapp btn-block">
                    <MdWhatsapp /> GRUPOS NO WHATSAPP
                  </Button>
                </a>
              </div>
            </Col>

            <Col lg={3}>
              <br></br>
              <Image
                src={qr}
                height="250px"
                className="d-block teste"
              />
            </Col>
          </Row>
        </Container>


        <Container className="mb-5">
          <Row>
            <Col xs={12} className="text-center mt-5">
              <h2 className="mb-3">Quais os benefícios?</h2>
              <Row className="beneficios-section text-center">
                <Col md={3} className="beneficio-item">
                  <div className="beneficio-icon-container">
                    <FaShoppingBag className="beneficio-icon" />
                  </div>
                  <h3 style={{ color: '#0052B3' }}>Promoções diárias</h3>
                  <p style={{ color: 'black' }}>Receba no conforto da sua casa as melhores promoções das principais varejistas do Brasil!</p>
                </Col>
                <Col md={3} className="beneficio-item-2">
                  <div className="beneficio-icon-container-2">
                    <FaHandshake className="beneficio-icon-2" />
                  </div>



                  <h3>Apoio na compra</h3>
                  <p >Conte conosco para garantir que fará uma excelente compra, com segurança e pagando barato!</p>
                </Col>
                <Col md={3} className="beneficio-item">
                  <div className="beneficio-icon-container">
                    <FaQuestionCircle className="beneficio-icon" />
                  </div>
                  <h3 style={{ color: '#0052B3' }}>Tire suas dúvidas</h3>
                  <p style={{ color: 'black' }} >Tá com alguma dúvida sobre alguma oferta? Entre em contato conosco que iremos lhe ajudar!</p>
                </Col>
                <Col md={3} className="beneficio-item-2">
                  <div className="beneficio-icon-container-2">
                    <FaHistory className="beneficio-icon-2" />
                  </div>
                  <h3 >Histórico de Preços</h3>
                  <p>Tá querendo comprar algum produto mas tá em dúvida se tá barato? Confira nosso histórico de preços no Telegram.</p>
                </Col>
              </Row>
            </Col>
            <Col xs={12} className="text-center mt-5">
              <h2 className="mb-3">Como funcionam os grupos?</h2>
              <Row className="my-3 align-items-center">
                <Col>
                  <div className="video-container">
                    <iframe
                      width="560"
                      height="315"
                      src="https://www.youtube.com/embed/W74iJfbEMnE"
                      title="Vídeo YouTube"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen>
                    </iframe>
                  </div>
                </Col>
              </Row>
            </Col>
            <br />
            <br />
            <Col lg={6}>
              <br />
              <br />
              <div className="banner-buttons">
                <a href="https://t.me/s/cacadoresofertas" rel="noopener noreferrer" className="promo-button-link">
                  <Button variant="outline-light" className="btn-block btn-telegram">
                    <FaTelegramPlane /> GRUPO NO TELEGRAM
                  </Button>
                </a>
                <br />
                <a href="https://caçadoresdeofertas.com.br/whatsapp" rel="noopener noreferrer" className="promo-button-link">
                  <Button variant="success" className=" btn-whatsapp btn-block">
                    <MdWhatsapp /> GRUPOS NO WHATSAPP
                  </Button>
                </a>
              </div>
            </Col>


          </Row>
          <hr className="hr-big" />
        </Container>

      </div>
      <Footer />
    </>
  );
}
